import { CustomDimensions, SetCustomDimensionOrParam } from '../types';
import { createConfigParametersRepository } from '../../configParametersRepository';
import {
  CustomDimensionsOrParams,
  CustomParams,
} from '../google-analytics/ga4Types';
import {
  CUSTOM_DIMENSIONS_STORAGE_KEY,
  CUSTOM_PARAMS_STORAGE_KEY,
} from '../resources/constants';
import { checkThirdPartyTrackingStorageInit } from '../../configParametersRepository/storageClient/storage';

export const updateCustomParam = (params: SetCustomDimensionOrParam) => {
  checkThirdPartyTrackingStorageInit();
  const { value } = params;
  const { getTrackingStorageClient } = createConfigParametersRepository();
  const storageClient = getTrackingStorageClient();
  if ('customParam' in params) {
    storageClient?.updateCustomParamsAndDimensions({
      [params.customParam]: value,
    });
    return;
  }
  const dimensionName = `dimension${params.customDimension}`;
  storageClient?.updateCustomParamsAndDimensions({
    [dimensionName]: value,
  });
};

export const updateCustomParams = (params: CustomDimensionsOrParams) => {
  checkThirdPartyTrackingStorageInit();
  const { getTrackingStorageClient } = createConfigParametersRepository();
  const storageClient = getTrackingStorageClient();
  storageClient?.updateCustomParamsAndDimensions(params);
};

export const getGaCustomDimensions = () => {
  checkThirdPartyTrackingStorageInit();
  const { getTrackingStorageClient } = createConfigParametersRepository();
  const storageClient = getTrackingStorageClient();
  return storageClient?.getTrackingStoredValue(
    CUSTOM_DIMENSIONS_STORAGE_KEY
  ) as CustomDimensions;
};

export const getGaCustomParams = () => {
  checkThirdPartyTrackingStorageInit();
  const { getTrackingStorageClient } = createConfigParametersRepository();
  const storageClient = getTrackingStorageClient();
  return storageClient?.getTrackingStoredValue(
    CUSTOM_PARAMS_STORAGE_KEY
  ) as CustomParams;
};
